// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { miniMyAccountStyles } from "@werner/App/Components/MiniMyAccount/MiniMyAccount";
import { color, linkArrowStyle, styledScrollbar, xScreen } from "@werner/XDL/Utilities";
import { css } from "styled-components";

miniMyAccountStyles.container = {
    css: css`
        width: 100%;
    `,
};
miniMyAccountStyles.header = {
    css: css`
        padding: 35px 30px;
        width: 100%;
        text-align: center;
        ${xScreen("lt", "md")} {
            display: none;
        }
    `,
};
miniMyAccountStyles.titleLink = {
    color: "text.main",
    typographyProps: {
        size: 28,
        weight: 500,
        css: css`
            letter-spacing: 0;
            line-height: 32px;

            &&&:hover {
                color: ${color("text.link")};
            }
        `,
    },
};
miniMyAccountStyles.infoGridContainer = {
    gap: 40,
    css: css`
        padding: 25px 20px 20px;
        background-color: ${color("primary", 0.05)};
        max-height: calc(100vh - 410px);
        overflow-x: hidden;
        ${styledScrollbar()}
        ${xScreen("lt", "md")} {
            max-height: none;
            background-color: transparent;
        }
    `,
};
miniMyAccountStyles.infoGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        display: flex;
        flex-direction: column;
        gap: 14px;
    `,
};
miniMyAccountStyles.infoTitle = {
    size: 15,
    weight: 500,
    css: css`
        width: 100%;
        padding-bottom: 4px;
        border-bottom: 1px solid ${color("common.ui1")};
        letter-spacing: 0;
        line-height: 22px;
    `,
};
miniMyAccountStyles.linksContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 4px;
    `,
};
miniMyAccountStyles.link = {
    color: "secondary",
    typographyProps: {
        size: 15,
        weight: "normal",
        css: css`
            letter-spacing: 0;
            line-height: 22px;
        `,
    },
    css: css`
        align-self: baseline;
        margin-bottom: 5px;
    `,
};
miniMyAccountStyles.sectionWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};
miniMyAccountStyles.sectionTitle = {
    size: 15,
    weight: 500,
    color: "text.main",
    css: css`
        line-height: 20px;
        margin-bottom: 8px;
    `,
};
miniMyAccountStyles.customerInfoSecondaryText = {
    size: 15,
    weight: 400,
    color: "text.main",
    css: css`
        line-height: 20px;
        margin-bottom: 2px;
        text-transform: capitalize;
    `,
};
miniMyAccountStyles.actionWrapper = {
    css: css`
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 90px;
        padding: 32px 38px 30px;
        &&&& {
            ${xScreen("lt", "md")} {
                flex-direction: column;
                gap: 20px;
                padding: 32px 10px 30px 0;
                width: 100%;
            }
        }
    `,
};
miniMyAccountStyles.changeShipToButton = {
    variant: "primary",
    sizeVariant: "large",
    mergeCss: true,
    css: css`
        height: 46px;
        min-height: 46px;
        width: 267px;
        text-align: left;
        ${xScreen("lt", "md")} {
            width: 100%;
        }
    `,
};
miniMyAccountStyles.signOutLink = {
    ...linkArrowStyle,
};
